import { render, staticRenderFns } from "./object-input.vue?vue&type=template&id=bf69997e&scoped=true&"
import script from "./object-input.vue?vue&type=script&lang=js&"
export * from "./object-input.vue?vue&type=script&lang=js&"
import style0 from "./object-input.vue?vue&type=style&index=0&id=bf69997e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf69997e",
  null
  
)

export default component.exports